import type { SourceProviderIcon, UserTaskSource } from "@/types/userTasks.ts";
import { type SourceTarget, sourceRefs, sourceTarget } from "@/shared/userTaskSources.ts";

/** Web's address for a page a source opens. */
const href = (target: SourceTarget | undefined): string | undefined => {
  if (!target) return undefined;
  return target.kind === "thread" ? `/threads/${target.threadId}` : `/sources/${target.sourceId}`;
};

/** A source's own page, as a web route. Which page it is is decided in `@/shared`. */
export function sourceHref(source: UserTaskSource): string | undefined {
  return href(sourceTarget(source));
}

export type SourceLink = {
  key: string;
  label: string;
  href: string | undefined;
  /** The service it came through, so a row can wear its mark. */
  providerIcon: SourceProviderIcon | undefined;
  /** A conversation with okthx, which wears okthx's own mark. */
  conversation: boolean;
};

/** The links a task's sources show, each at its web address. */
export function sourceLinks(
  sources: UserTaskSource[],
  workedInThreadId?: number | null,
): SourceLink[] {
  return sourceRefs(sources, workedInThreadId).map(
    ({ key, label, target, providerIcon, conversation }) => ({
      key,
      label,
      href: href(target),
      providerIcon,
      conversation,
    }),
  );
}
